import AdminLayout from '@/layouts/admin/AdminLayout.vue'
import {useAuthentication} from '@/services/useAuthentication.ts'

const { beforeEnter } = useAuthentication()

export default [
  {
    path: '/admin',
    beforeEnter,
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'dashboard',
        meta: {
          title: 'Dashboard',
        },
        component: () => import('@/views/admin/DashboardPage.vue'),
      },
      {
        path: 'analisi',
        name: 'analisi',
        meta: {
          title: 'Analisi',
        },
        component: () => import('@/views/admin/AnalisiPage.vue'),
      },
      {
        path: 'report',
        name: 'report',
        meta: {
          title: 'Report',
        },
        component: () => import('@/views/admin/ReportPage.vue'),
      },
      {
        path: 'blog',
        name: 'blog',
        meta: {
          title: 'Blog',
        },
        component: () => import('@/views/admin/DashboardPage.vue'),
      },
      {
        path: 'utenti',
        name: 'utenti',
        meta: {
          title: 'Utenti',
          requiresRole: 'admin',
        },
        component: () => import('@/views/admin/UsersPage.vue'),
      },
    ],
  },
]
